import { render, staticRenderFns } from "./raTextConfigComponent.vue?vue&type=template&id=1125b040&scoped=true&"
import script from "./raTextConfigComponent.vue?vue&type=script&lang=js&"
export * from "./raTextConfigComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1125b040",
  null
  
)

export default component.exports